import { conversion } from 'country-configuration/currency/conversion'
import type { Prices } from 'product/types/Prices'
import type { CountryConfiguration } from 'types/countryConfiguration'
import { defaultInitState } from '../../store/pricesStore/pricesStore'

type PricesStoreDataProps = {
	readonly prices?: Prices
	readonly hidePriceHistory?: boolean
	readonly showAdditionalCurrencies?: boolean
	readonly country: CountryConfiguration
}

export const getPricesStoreData = ({
	prices,
	showAdditionalCurrencies,
	country,
}: PricesStoreDataProps) => {
	if (!prices) {
		return { price: defaultInitState.price }
	}

	const { price: priceWithCurrency, additionalPrices } = conversion(
		prices.price,
		country,
		undefined,
		showAdditionalCurrencies
	)

	return {
		price: {
			amount: prices.price,
			formatted: priceWithCurrency,
			additionalPrices: additionalPrices ?? [],
		},
		crossedOutPrices: prices.crossedOutPrices?.map((price) => {
			const {
				price: crossedPriceWithCurrency,
				additionalPrices: crossedAdditionalPrices,
			} = conversion(price, country, undefined, showAdditionalCurrencies)

			return {
				amount: price,
				formatted: crossedPriceWithCurrency,
				additionalPrices: crossedAdditionalPrices ?? [],
			}
		}),
		allCrossedOutWithoutLowest: prices.allCrossedOutWithoutLowest?.map(
			(price) => {
				const {
					price: allCrossedOutWithoutLowestPriceWithCurrency,
					additionalPrices: allCrossedOutWithoutLowestAdditionalPrices,
				} = conversion(price, country, undefined, showAdditionalCurrencies)

				return {
					amount: price,
					formatted: allCrossedOutWithoutLowestPriceWithCurrency,
					additionalPrices: allCrossedOutWithoutLowestAdditionalPrices ?? [],
				}
			}
		),
	}
}
